import React from 'react';
// ui
import Icon from '@material-ui/core/Icon';

const ItemHeader = ({ itemsIdx, callBackhandleItem, hasItem }) => {
    // 아이템 정렬, 복사, 삭제
    const handleItem = e => {
        const action = e.target.name;
        callBackhandleItem(action, itemsIdx);
    };

    return (
        <div className="item-header">
            <div className="item-header-move-btn-wrap">
                <button type="button" onClick={handleItem} name="up">
                    &#x3c;
                </button>
                <button type="button" onClick={handleItem} name="down">
                    &#x3e;
                </button>
            </div>
            <div className="item-header-edit-btn-wrap">
                <button type="button" onClick={handleItem} name="copy" title="복사">
                    <Icon>file_copy</Icon>
                </button>
                {hasItem !== 1 && (
                    <button
                        type="button"
                        onClick={handleItem}
                        name="del"
                        title="삭제"
                    >
                        <Icon>delete_outline</Icon>
                    </button>
                )}
            </div>
        </div>
    );
};

export default ItemHeader;
